import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiSubscription } from '@wix/da-papi-types';
import MobileHeroCard from '../MobileHeroCard';
import { type PackagePickerStoreSlice } from '../../../../../redux/packagePicker/types';
import { formatSaleEndDate } from '../../../utils';
import { usePackagePickerOrder } from '../../../hooks';

import s from './HeroTableMobile.scss';

interface Props {
  currentCoreSubscription?: PapiSubscription;
  sale?: PackagePickerStoreSlice['sale'];
  saleEndDate?: string;
  referer: string;
}

const HeroTableMobile: React.FC<Props> = ({ sale, saleEndDate, referer }) => {
  const { t } = useTranslation();
  const packagePickerOrder = usePackagePickerOrder();

  return (
    <>
      {packagePickerOrder.map(coreType => (
        <MobileHeroCard key={coreType} coreType={coreType} referer={referer} />
      ))}
      {sale?.ppShowLegal && saleEndDate && (
        <div className={s['disclaimer']}>
          {t('packagePicker.heroTable.saleDisclaimer', {
            endDate: formatSaleEndDate(saleEndDate),
          })}
        </div>
      )}
    </>
  );
};

export default HeroTableMobile;
